/* Sunny Stripes - commercial maintenance program builder.
   No price is set in this file. Every figure comes from assets/ss-rates.js,
   and the whole season is assembled by SS_RATES.comProgram() so that the page,
   the lead email and the confirmation can never disagree by a rounding step.

   Two ways to tell us the size, and only one of them wins at a time:
     MAP    the customer traces turf and beds and pins the trees. Preferred -
            it is the only input that produces a fall cleanup number worth
            quoting, because leaf load follows tree count, not turf area.
     ROUGH  a size card plus two dropdowns, for someone who cannot find their
            property on a satellite image or is on a phone in a car park.
   Drawing anything switches to MAP; touching a size card switches to ROUGH.

   Above three acres nothing is quoted - see COMMERCIAL.maxAcres in the rate
   card. The sheet swaps to the site-walk message and the form still sends.
*/
(function(){
  "use strict";

  var SS = window.SS_RATES;
  if (!SS) {
    console.error("Sunny Stripes: assets/ss-rates.js did not load - the commercial maintenance builder cannot price anything. Check that the maintenance page renders it before this file.");
    return;
  }

  var KLAVIYO = { publicApiKey:"SKBLA9" };

  var GOOGLE = {
    apiKey: "AIzaSyB8JkZAqLw39qEuj3FKGUsVQ9Yzp5mIAck",
    center: { lat:43.75, lng:-87.75 },
    bounds: { west:-88.20, south:43.53, east:-87.58, north:43.90 },
    region: "us", state: "WI", county: "sheboygan"
  };

  var TOWNS = ["Adell","Cascade","Cedar Grove","Elkhart Lake","Glenbeulah","Howards Grove",
               "Kohler","Oostburg","Plymouth","Random Lake","Sheboygan","Sheboygan Falls",
               "Waldo","Town of Wilson"];

  /* Weekly and all four services are the defaults because that is what a
     property the public sees actually needs. Someone who wants less will
     untick; someone shown a thin program assumes we do not do the rest. */
  var S = {
    source: "map",            /* "map" or "rough" */
    freq: "weekly",
    svc: { mow:true, beds:true, fert:true, cleanups:true },
    roughTurf: null,          /* size-card area, sq ft */
    roughBeds: 2500,          /* matches the select's default option */
    roughTrees: 0,
    /* The rough inputs have defaults so the dropdown is not blank, but a
       default is not an answer. Until the customer actually touches one of
       them the sheet must stay empty - quoting bed care to someone who has
       told us nothing is how a tool loses trust in its first ten seconds. */
    roughUsed: false,
    roughOverCap: false,      /* they picked the "3+ acres" card */
    outOfArea: false,
    placeLoc: null,
    sent: false
  };

  var $ = function(id){ return document.getElementById(id); };
  var money = function(n){ return "$" + Math.round(n).toLocaleString("en-US"); };
  var esc = function(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); };
  var num = function(n){ return Math.round(n).toLocaleString("en-US"); };
  function hideErr(id){ var e = $(id); if (e) e.style.display = "none"; }

  /* ---------------- what the customer drew ---------------- */
  var MEAS = null;

  var SURFACES = [
    { key:"turf", label:"Lawn we'd mow",   mode:"area",  color:"#4c8a54" },
    { key:"bed",  label:"Planting beds",   mode:"area",  color:"#8a6a3f" },
    { key:"tree", label:"Mature tree",     mode:"point", color:"#1b4423", pin:"T" }
  ];

  var HINTS = {
    turf: "Click the corners of each piece of lawn, then Finish shape. Draw every separate piece.",
    bed:  "Trace the planting beds the same way - islands, foundation beds, entry beds.",
    tree: "Click each mature tree. This is what makes the fall cleanup number honest."
  };

  function initMeasure(){
    if (MEAS && !MEAS.notReady) return;
    if (!window.SS_MEASURE || !SS_MEASURE.ready()) return;
    var el = $("cmmap");
    if (!el || !el.clientHeight) return;
    MEAS = SS_MEASURE.create({
      mapEl: el,
      center: S.placeLoc || GOOGLE.center,
      zoom: S.placeLoc ? 19 : 13,
      surfaces: SURFACES,
      onChange: onMeasureChange,
      onStuck: measureStuck
    });
    if (MEAS.notReady){ MEAS = null; return; }
    buildSurfaceChips();
    renderMeasure();
  }

  function buildSurfaceChips(){
    var box = $("cmsurf");
    if (!box) return;
    box.innerHTML = SURFACES.map(function(sf){
      return '<button type="button" data-surf="' + sf.key + '">' +
             '<span class="dot" style="background:' + sf.color + '"></span>' +
             esc(sf.label) + '</button>';
    }).join("");
  }

  /* The map is the better input, so any drawing takes the property back off
     the rough estimates without the customer having to undo anything. */
  function onMeasureChange(){
    if (MEAS && !MEAS.notReady && !MEAS.isEmpty()) {
      S.source = "map";
      var body = $("cmroughBody");
      if (body) body.classList.remove("open");
      [].forEach.call(document.querySelectorAll("#cmcards .cmcard"), function(c){
        c.classList.remove("sel");
      });
      S.roughTurf = null;
    }
    renderMeasure();
    render();
  }

  /* Google's map sometimes never draws - assets/ss-measure.js explains why.
     Take the drawing furniture away and push the rough sizes forward instead,
     so the visitor still leaves with a number. */
  function measureStuck(){
    ["#cmsurf", "#cmhint", ".cmtools", "#cmshapes", "#cmmeasured"].forEach(function(sel){
      var el = document.querySelector("#cmapp " + sel);
      if (el) el.style.display = "none";
    });
    S.source = "rough";
    var body = $("cmroughBody"), tog = $("cmroughToggle");
    if (body) body.classList.add("open");
    if (tog) tog.textContent = "Tell us the rough sizes";
    if (!S.roughTurf) S.roughTurf = 9500;   /* the Large card, a fair middle */
    S.roughUsed = true;
    syncCards();
    render();
  }

  function measured(){
    if (!MEAS || MEAS.notReady || MEAS.stuck) return null;
    var t = MEAS.totals();
    return {
      turf:  t.turf ? t.turf.sqft  : 0,
      beds:  t.bed  ? t.bed.sqft   : 0,
      trees: t.tree ? t.tree.count : 0,
      turfAreas: t.turf ? t.turf.count : 0,
      bedAreas:  t.bed  ? t.bed.count  : 0
    };
  }

  function renderMeasure(){
    if (!MEAS || MEAS.notReady || MEAS.stuck) return;
    var cur = MEAS.currentSurface();

    var chips = $("cmsurf");
    if (chips) [].forEach.call(chips.querySelectorAll("button"), function(b){
      b.classList.toggle("on", b.dataset.surf === cur);
    });

    var drafting = MEAS.drafting(), pts = MEAS.draftPoints();
    var mode = (SURFACES.filter(function(sf){ return sf.key === cur; })[0] || {}).mode;
    var need = mode === "area" ? 3 : 2;
    var txt = $("cmhintTxt"), fin = $("cmfinish");
    if (txt){
      txt.innerHTML = drafting
        ? (pts >= need
            ? "<b>" + pts + " points</b> - keep clicking, or Finish shape."
            : "<b>" + pts + "</b> of " + need + " points needed.")
        : esc(HINTS[cur] || "Click the map to start.");
    }
    if (fin) fin.disabled = !(drafting && pts >= need);

    var t = MEAS.totals(), out = "";
    SURFACES.forEach(function(sf){
      var r = t[sf.key];
      if (!r || !r.count) return;
      var v = sf.mode === "area"
        ? num(r.sqft) + " sq ft"
        : r.count + (r.count === 1 ? " tree" : " trees");
      out += '<span class="cmchip"><span class="dot" style="background:' + sf.color + '"></span>' +
             esc(sf.label) + ' <b>' + v + '</b></span>';
    });
    var box = $("cmmeasured");
    if (box) box.innerHTML = out;

    var list = $("cmshapes");
    if (list){
      list.innerHTML = MEAS.shapes().map(function(sh, i){
        var sf = SURFACES.filter(function(x){ return x.key === sh.surface; })[0] || {};
        var size = sh.mode === "area" ? num(sh.sqft) + " sq ft" : "marked";
        return '<div class="cmshape"><span>' + esc(sf.label || sh.surface) + " #" + (i + 1) +
               ' &middot; ' + size + '</span><button type="button" class="x" data-rm="' + sh.id +
               '" aria-label="Remove">Remove</button></div>';
      }).join("");
    }
  }

  /* ---------------- rough sizes, for people who can't use the map ---------- */
  function buildCards(){
    var box = $("cmcards");
    if (!box) return;
    box.innerHTML = SS.tiers.map(function(t){
      return '<div class="cmcard" data-area="' + (t.area == null ? "" : t.area) + '">' +
             '<div class="nm">' + esc(t.nm) + '</div>' +
             '<div class="sz">' + esc(t.com) + '</div>' +
             '<div class="sz">' + esc(t.sz) + '</div>' +
             '</div>';
    }).join("");
  }

  function syncCards(){
    [].forEach.call(document.querySelectorAll("#cmcards .cmcard"), function(c){
      var a = c.dataset.area === "" ? null : parseInt(c.dataset.area, 10);
      c.classList.toggle("sel", S.source === "rough" && a === S.roughTurf);
    });
  }

  /* What we are actually pricing, whichever way they told us. Anything drawn
     wins over the rough sizes, and neither counts until it exists. */
  function property(){
    var m = measured();
    if (m && (m.turf || m.beds || m.trees)) {
      return { turf:m.turf, beds:m.beds, trees:m.trees, drawn:true,
               turfAreas:m.turfAreas, bedAreas:m.bedAreas };
    }
    if (S.roughUsed) {
      return { turf: S.roughTurf || 0, beds: S.roughBeds, trees: S.roughTrees,
               drawn:false, turfAreas:0, bedAreas:0 };
    }
    return { turf:0, beds:0, trees:0, drawn:false, turfAreas:0, bedAreas:0 };
  }

  function program(){
    var p = property();
    return SS.comProgram({
      turfSqft: p.turf, bedSqft: p.beds, trees: p.trees,
      frequency: S.freq, services: S.svc
    });
  }

  /* ---------------- the service checklist ---------------- */
  var SVC_COPY = {
    mow:      { nm:"Mowing, trimming & edging",
                sub:"Cut, trimmed around every obstacle, edges cut along walks and drives, and blown clean before we leave." },
    beds:     { nm:"Bed care & shrub trimming",
                sub:"Weeding, pruning, and re-cut bed edges that hold their line all season." },
    fert:     { nm:"Fertilization & weed control",
                sub:"Applications timed to our growing season, not a national calendar." },
    cleanups: { nm:"Spring & fall cleanups",
                sub:"Winter debris cleared at green-up; leaves off and the property put to bed in November." }
  };

  function buildSvcs(){
    var box = $("cmsvcs");
    if (!box) return;
    box.innerHTML = ["mow","beds","fert","cleanups"].map(function(k){
      var c = SVC_COPY[k];
      return '<div class="cmsvc" data-svc="' + k + '">' +
             '<span class="box">&#10003;</span>' +
             '<span><span class="nm">' + esc(c.nm) + '</span>' +
             '<span class="sub">' + esc(c.sub) + '</span></span>' +
             '<span class="amt" data-amt="' + k + '">&nbsp;</span></div>';
    }).join("");
  }

  /* Each row shows what that service costs for the season, so someone can see
     what ticking it off would actually save before they tick it off. */
  function svcAmounts(){
    var p = property();
    var keys = ["mow","beds","fert","cleanups"];
    keys.forEach(function(k){
      var el = document.querySelector('#cmsvcs [data-amt="' + k + '"]');
      var row = document.querySelector('#cmsvcs .cmsvc[data-svc="' + k + '"]');
      if (row) row.classList.toggle("on", !!S.svc[k]);
      if (!el) return;
      var only = { mow:false, beds:false, fert:false, cleanups:false };
      only[k] = true;
      var r = SS.comProgram({ turfSqft:p.turf, bedSqft:p.beds, trees:p.trees,
                              frequency:S.freq, services:only });
      if (r.custom || !r.season){ el.innerHTML = "&nbsp;"; return; }
      el.innerHTML = money(r.season) + "<small>for the season</small>";
    });
  }

  /* ---------------- the program sheet ---------------- */
  function render(){
    var p = property(), r = program();

    /* property line */
    var propEl = $("cmshProp"), metaEl = $("cmshMeta");
    var addr = ($("cmaddr").value || "").trim();
    var city = $("cmcity").value || "";
    if (propEl){
      propEl.textContent = addr
        ? (addr + (city && city !== "other" ? ", " + city : ""))
        : "Draw the property to begin";
    }
    if (metaEl){
      if (!p.turf && !p.beds){
        metaEl.textContent = "Nothing measured yet";
      } else {
        var bits = [];
        if (p.turf)  bits.push(num(p.turf) + " sq ft lawn" +
          (p.drawn && p.turfAreas > 1 ? " across " + p.turfAreas + " areas" : ""));
        if (p.beds)  bits.push(num(p.beds) + " sq ft beds");
        if (p.trees) bits.push(p.trees + (p.trees === 1 ? " tree" : " trees"));
        metaEl.textContent = bits.join(" · ") + (p.drawn ? " · measured from satellite" : " · rough sizes");
      }
    }

    svcAmounts();

    var items = $("cmitems"), totalBox = $("cmtotalBox"), custom = $("cmcustom");

    if (r.custom){
      if (items) items.innerHTML = '<div class="cmempty">Over three acres &mdash; we build this one by hand.</div>';
      if (totalBox) totalBox.style.display = "none";
      /* Blank the figures as well as hiding the box. A hidden element still
         holds its text, and a stale season total sitting behind a display:none
         is one CSS change away from being shown to the wrong property. */
      $("cmMonthly").innerHTML = "&mdash;";
      $("cmSeason").innerHTML = "&mdash;";
      if (custom) custom.classList.add("show");
      return;
    }
    if (custom) custom.classList.remove("show");
    if (totalBox) totalBox.style.display = "block";

    if (!r.lines.length){
      if (items){
        items.innerHTML = '<div class="cmempty">' +
          (p.turf || p.beds
            ? "Tick a service to build the program."
            : "Draw the lawn, or give us rough sizes, and the program builds itself.") +
          '</div>';
      }
      $("cmMonthly").innerHTML = "&mdash;";
      $("cmMonthlyLbl").textContent = "per month";
      $("cmSeason").innerHTML = "&mdash;";
      return;
    }

    if (items){
      items.innerHTML = r.lines.map(function(l){
        return '<div class="cmitem"><span class="nm">' + esc(l.label) +
               '<small>' + esc(l.detail) + " &middot; " + money(l.each) +
               (l.count > 1 ? " each" : "") + '</small></span>' +
               '<span class="amt">' + money(l.total) + '</span></div>';
      }).join("");
    }
    $("cmMonthly").textContent = money(r.monthly);
    $("cmMonthlyLbl").textContent = "per month, spread over " + r.months + " invoices";
    $("cmSeason").textContent = money(r.season);
  }

  /* ---------------- address autocomplete ---------------- */
  var AC = { ready:false, lib:null, token:null, sug:[], active:-1, timer:null };
  var PIN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

  function buildTowns(){
    var sel = $("cmcity");
    if (!sel) return;
    sel.innerHTML = '<option value="">Select&hellip;</option>' +
      TOWNS.map(function(t){ return '<option>' + t + '</option>'; }).join("") +
      '<option value="other">Other Sheboygan County town</option>';
  }

  function loadMaps(){
    if (window.google && window.google.maps && window.google.maps.importLibrary) return initAC();
    if (document.getElementById("cm-gmaps")) return;
    window.__cmGmaps = initAC;
    var sc = document.createElement("script");
    sc.id = "cm-gmaps"; sc.async = true;
    sc.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE.apiKey) +
             "&libraries=places,geometry&v=weekly&callback=__cmGmaps";
    sc.onerror = function(){ AC.ready = false; };
    document.head.appendChild(sc);
  }
  function initAC(){
    try{
      google.maps.importLibrary("places").then(function(lib){
        AC.lib = lib; AC.ready = !!(lib && lib.AutocompleteSuggestion);
      })["catch"](function(){ AC.ready = false; });
      google.maps.importLibrary("geometry").then(function(){ initMeasure(); })["catch"](function(){});
    }catch(e){ AC.ready = false; }
  }
  function acClose(){
    var b = $("cmsuggest");
    b.classList.remove("open"); b.innerHTML = "";
    AC.sug = []; AC.active = -1;
  }
  function acFetch(q){
    if (!AC.ready || q.length < 3) return acClose();
    try{
      if (!AC.token && AC.lib.AutocompleteSessionToken) AC.token = new AC.lib.AutocompleteSessionToken();
      AC.lib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: q, sessionToken: AC.token || undefined,
        includedRegionCodes: [GOOGLE.region],
        locationRestriction: GOOGLE.bounds
      }).then(function(res){ AC.sug = (res && res.suggestions) || []; acRender(); })
        ["catch"](function(){ acClose(); });
    }catch(e){ acClose(); }
  }
  function acRender(){
    var box = $("cmsuggest"), html = "", n = 0;
    AC.sug.forEach(function(s,i){
      var p = s.placePrediction; if (!p) return;
      var main = (p.mainText && p.mainText.text) || (p.text && p.text.text) || "";
      var sub  = (p.secondaryText && p.secondaryText.text) || "";
      html += '<div class="as-item" data-i="'+i+'" role="option">' + PIN +
              '<span><span class="as-main">'+esc(main)+'</span> <span class="as-sub">'+esc(sub)+'</span></span></div>';
      n++;
    });
    if (!n) return acClose();
    html += '<div class="as-foot">Powered by Google</div>';
    box.innerHTML = html; box.classList.add("open"); AC.active = -1;
  }
  function acMove(d){
    var items = $("cmsuggest").querySelectorAll(".as-item");
    if (!items.length) return;
    AC.active = (AC.active + d + items.length) % items.length;
    for (var i=0;i<items.length;i++) items[i].classList.toggle("active", i===AC.active);
  }
  function acChoose(i){
    var s = AC.sug[i]; if (!s || !s.placePrediction) return;
    var p = s.placePrediction;
    try{
      var place = p.toPlace();
      place.fetchFields({ fields:["addressComponents","formattedAddress","location"] }).then(function(){ acFill(place); })
        ["catch"](function(){ $("cmaddr").value = (p.text && p.text.text) || $("cmaddr").value; });
    }catch(e){ $("cmaddr").value = (p.text && p.text.text) || $("cmaddr").value; }
    AC.token = null; acClose();
  }
  function acFill(place){
    var c = place.addressComponents || [];
    function get(t, short){
      for (var i=0;i<c.length;i++){
        var types = c[i].types || [];
        if (types.indexOf(t) >= 0) return (short ? c[i].shortText : c[i].longText) || c[i].longText || "";
      }
      return "";
    }
    var street = ((get("street_number") ? get("street_number") + " " : "") + get("route")).trim();
    $("cmaddr").value = street || place.formattedAddress || $("cmaddr").value;
    $("cmaddr").classList.remove("bad");
    var city = get("locality") || get("sublocality") || get("administrative_area_level_3");
    var state = get("administrative_area_level_1", true);
    var county = get("administrative_area_level_2");
    var zip = get("postal_code");
    if (zip) $("cmzip").value = zip;

    /* Put the map on their roof rather than making them hunt for it. */
    if (place.location){
      S.placeLoc = { lat: place.location.lat(), lng: place.location.lng() };
      if (MEAS && !MEAS.notReady) MEAS.recenter(S.placeLoc, 19);
      else initMeasure();
    }

    var sel = $("cmcity"), matched = false;
    if (city){
      for (var i=0;i<sel.options.length;i++){
        if (sel.options[i].text.toLowerCase() === city.toLowerCase()){ sel.selectedIndex = i; matched = true; break; }
      }
      if (!matched) sel.value = "other";
      sel.classList.remove("bad");
    }

    var msg = $("cmareaMsg");
    var outOfState  = state  && state !== GOOGLE.state;
    var outOfCounty = county && county.toLowerCase().indexOf(GOOGLE.county) < 0;
    msg.style.display = "block";
    if (outOfState || outOfCounty){
      S.outOfArea = true;
      msg.innerHTML = "That address is outside Sheboygan County. Send it through anyway and we'll " +
                      "tell you honestly whether we can run a crew there.";
      sel.classList.add("bad");
    } else {
      S.outOfArea = false;
      msg.innerHTML = "&#10003; " + esc(city || "That address") + " is in Sheboygan County - we maintain properties across the county.";
      hideErr("cmerr1");
    }
    render();
  }

  /* ---------------- lead delivery ---------------- */
  function ssPostForm(id, fields){
    var f = document.getElementById(id);
    if (!f) return false;
    Object.keys(fields).forEach(function(k){
      var el = f.querySelector('[name="' + k + '"]');
      if (el) el.value = fields[k];
    });
    try{
      if (window.Shopify && Shopify.captcha && Shopify.captcha.protect){
        Shopify.captcha.protect(f, function(){ try{ f.submit(); }catch(e){} });
        return true;
      }
    }catch(e){}
    var b = f.querySelector('[type="submit"]');
    if (b){ b.click(); return true; }
    if (f.requestSubmit){ f.requestSubmit(); return true; }
    f.submit();
    return true;
  }
  function ssPhoneE164(p){
    var d = String(p || "").replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return null;
  }
  function ssKlaviyo(metricName, p){
    if (!KLAVIYO.publicApiKey) return;
    try{
      var prof = { email: p.email, first_name: p.first_name, last_name: p.last_name,
                   organization: p.company };
      var e164 = ssPhoneE164(p.phone_number);
      if (e164) prof.phone_number = e164;
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(KLAVIYO.publicApiKey), {
        method:"POST",
        headers:{ "Content-Type":"application/json", "revision":"2024-10-15" },
        body: JSON.stringify({ data:{ type:"event", attributes:{
          metric:{ data:{ type:"metric", attributes:{ name: metricName } } },
          properties: p,
          profile:{ data:{ type:"profile", attributes: prof } }
        } } })
      })["catch"](function(){});
    }catch(e){}
  }
  function pad(label){ return (label + " ").padEnd ? (label + " ").padEnd(30, ".") : label + " ......"; }

  function leadSummary(p, r){
    var L = [];
    L.push("COMMERCIAL MAINTENANCE PROGRAM - " + p.reference);
    L.push("");
    L.push("Name:      " + (p.first_name + " " + p.last_name).trim());
    L.push("Company:   " + (p.company || "-"));
    L.push("Email:     " + p.email);
    L.push("Phone:     " + p.phone_number);
    L.push("Property:  " + p.address + ", " + p.city + " " + p.zip);
    if (p.out_of_area) L.push("*** OUTSIDE SHEBOYGAN COUNTY - check we can run a crew there. ***");
    L.push("");
    L.push(p.drawn ? "MEASURED FROM SATELLITE - drawn by the customer"
                   : "ROUGH SIZES - the customer did not draw the property");
    /* The 3+ acres card has no area behind it, only a sentinel just past the
       cap. Printing that as a measurement would read "3.00 acres" next to
       "OVER THREE ACRES" and waste ten seconds of whoever picks up the lead. */
    if (p.over_cap_card) {
      L.push("  " + pad("Lawn") + " over " + SS.commercial.maxAcres +
             " acres - they picked the largest card, no size given");
    } else {
      L.push("  " + pad("Lawn") + " " + num(p.turf_sqft) + " sq ft" +
             (p.turf_areas > 1 ? " across " + p.turf_areas + " areas" : ""));
    }
    L.push("  " + pad("Planting beds") + " " + num(p.bed_sqft) + " sq ft" +
           (p.bed_areas > 1 ? " across " + p.bed_areas + " areas" : ""));
    L.push("  " + pad("Mature trees") + " " + p.trees +
           (p.trees ? "  (drives the fall cleanup)" : ""));
    if (!p.over_cap_card) L.push("  " + pad("Acres of turf") + " " + p.acres);
    L.push("");
    if (p.quoted_custom){
      L.push("OVER THREE ACRES - nothing quoted online. Needs a walk and a plan.");
    } else {
      L.push("PROGRAM QUOTED (" + p.frequency + ")");
      r.lines.forEach(function(l){
        L.push("  " + pad(l.label) + " $" + num(l.each) + " x " + l.count +
               " = $" + num(l.total) + "   (" + l.detail + ")");
      });
      L.push("");
      L.push("  " + pad("SEASON TOTAL") + " $" + num(r.season));
      L.push("  " + pad("Monthly, over " + r.months) + " $" + num(r.monthly));
    }
    var off = [];
    ["mow","beds","fert","cleanups"].forEach(function(k){ if (!p.services[k]) off.push(k); });
    if (off.length) L.push("\n  They turned OFF: " + off.join(", "));
    if (p.notes){ L.push(""); L.push("Notes: " + p.notes); }
    L.push("");
    L.push("Marketing opt-in: " + (p.optin ? "yes" : "no"));
    L.push("Submitted from the maintenance page.");
    return L.join("\n");
  }

  function sendLead(p, r){
    if (!/^https?:$/.test(location.protocol)){
      console.log("(preview mode - lead not sent)\n" + leadSummary(p, r));
      return;
    }
    try{
      if (p.optin){
        ssPostForm("ssCustomerForm", {
          "contact[first_name]": p.first_name,
          "contact[last_name]":  p.last_name,
          "contact[email]":      p.email,
          "contact[tags]":       "Maintenance Lead, Commercial"
        });
      }
      ssPostForm("ssLeadForm", {
        "contact[name]":  (p.first_name + " " + p.last_name).trim(),
        "contact[email]": p.email,
        "contact[phone]": p.phone_number,
        "contact[body]":  leadSummary(p, r)
      });
    }catch(e){}
  }

  function validate(){
    var need = ["cmfname","cmemail","cmphone"], miss = [];
    need.forEach(function(id){
      var el = $(id), empty = !el.value.trim();
      el.classList.toggle("bad", empty);
      if (empty) miss.push(el);
    });
    var em = $("cmemail");
    if (em.value.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())){
      em.classList.add("bad"); miss.push(em);
    }
    var addr = $("cmaddr");
    if (!addr.value.trim()){ addr.classList.add("bad"); miss.push(addr); }
    var e = $("cmerr3");
    e.style.display = miss.length ? "block" : "none";
    e.textContent = "We need the property address, a name, a working email and a phone number.";
    if (miss.length) miss[0].focus();
    return !miss.length;
  }

  /* ---------------- events ---------------- */
  document.addEventListener("click", function(ev){
    var t = ev.target;
    if (!t || !t.closest || !t.closest("#cmapp")) {
      if (t && t.closest && !t.closest("#cmaddrField")) acClose();
      return;
    }

    var as = t.closest("#cmsuggest .as-item");
    if (as){ acChoose(parseInt(as.dataset.i,10)); return; }
    if (!t.closest("#cmaddrField")) acClose();

    var surfBtn = t.closest("#cmsurf button[data-surf]");
    if (surfBtn){ if (MEAS) MEAS.setSurface(surfBtn.dataset.surf); return; }
    if (t.id === "cmfinish"){ if (MEAS) MEAS.finish(); return; }
    if (t.id === "cmundo"){   if (MEAS) MEAS.undo();   return; }
    if (t.id === "cmclear"){  if (MEAS) MEAS.clear();  return; }
    var rm = t.closest("[data-rm]");
    if (rm){ if (MEAS) MEAS.remove(rm.dataset.rm); return; }

    if (t.id === "cmroughToggle"){
      $("cmroughBody").classList.toggle("open");
      return;
    }

    var card = t.closest("#cmcards .cmcard");
    if (card){
      var a = card.dataset.area === "" ? null : parseInt(card.dataset.area, 10);
      /* The 3+ acre card has no area; it is how someone tells us the property
         is past what we quote online without having to draw it. */
      S.roughTurf = a == null ? (SS.commercial.maxAcres * 43560 + 1) : a;
      S.roughOverCap = (a == null);
      S.source = "rough"; S.roughUsed = true;
      if (MEAS && !MEAS.notReady && !MEAS.stuck) MEAS.clear();
      syncCards(); render();
      return;
    }

    var fq = t.closest("#cmfreq button[data-freq]");
    if (fq){
      S.freq = fq.dataset.freq;
      [].forEach.call(document.querySelectorAll("#cmfreq button"), function(b){
        b.classList.toggle("on", b.dataset.freq === S.freq);
      });
      render();
      return;
    }

    var svc = t.closest("#cmsvcs .cmsvc[data-svc]");
    if (svc){ S.svc[svc.dataset.svc] = !S.svc[svc.dataset.svc]; render(); return; }
  });

  $("cmaddr").addEventListener("input", function(){
    S.outOfArea = false;
    var q = this.value.trim();
    this.classList.remove("bad");
    clearTimeout(AC.timer);
    AC.timer = setTimeout(function(){ acFetch(q); }, 180);
    render();
  });
  $("cmaddr").addEventListener("keydown", function(ev){
    if (!$("cmsuggest").classList.contains("open")) return;
    if (ev.key === "ArrowDown"){ ev.preventDefault(); acMove(1); }
    else if (ev.key === "ArrowUp"){ ev.preventDefault(); acMove(-1); }
    else if (ev.key === "Enter" && AC.active >= 0){ ev.preventDefault(); acChoose(AC.active); }
    else if (ev.key === "Escape"){ acClose(); }
  });
  $("cmcity").addEventListener("change", function(){ this.classList.remove("bad"); render(); });

  $("cmbedsRough").addEventListener("change", function(){
    S.roughBeds = parseInt(this.value, 10) || 0;
    S.source = "rough"; S.roughUsed = true;
    syncCards(); render();
  });
  $("cmtreesRough").addEventListener("input", function(){
    S.roughTrees = Math.max(0, parseInt(this.value, 10) || 0);
    S.source = "rough"; S.roughUsed = true;
    syncCards(); render();
  });

  ["cmfname","cmemail","cmphone"].forEach(function(id){
    $(id).addEventListener("input", function(){
      this.classList.remove("bad"); hideErr("cmerr3");
    });
  });

  /* ---------------- submit ---------------- */
  $("cmsend").addEventListener("click", function(){
    if (S.sent) return;
    if (!validate()) return;

    var prop = property(), r = program();
    var ref = "CM-" + String(Math.floor(Math.random()*9000)+1000);

    var payload = {
      first_name: $("cmfname").value.trim(),
      last_name:  $("cmlname").value.trim(),
      company:    $("cmcompany").value.trim(),
      email:      $("cmemail").value.trim(),
      phone_number: $("cmphone").value.trim(),
      address:    $("cmaddr").value.trim(),
      city:       $("cmcity").value,
      zip:        $("cmzip").value.trim(),
      notes:      $("cmnotes").value.trim(),
      optin:      $("cmoptin").checked,
      out_of_area: S.outOfArea,
      reference:  ref,
      source:     "commercial-maintenance",
      property_type: "commercial",
      drawn:      prop.drawn,
      turf_sqft:  prop.turf,
      turf_areas: prop.turfAreas,
      bed_sqft:   prop.beds,
      bed_areas:  prop.bedAreas,
      trees:      prop.trees,
      acres:      (prop.turf / 43560).toFixed(2),
      frequency:  S.freq,
      services:   S.svc,
      over_cap_card: !prop.drawn && S.roughOverCap,
      quoted_custom: !!r.custom,
      quoted_season:  r.custom ? null : r.season,
      quoted_monthly: r.custom ? null : r.monthly,
      /* snippets/ss-lead-forms.liquid reads quoted_total off the Klaviyo event
         to set the Google Ads conversion value. Leaving it null on a custom
         quote is deliberate - the hook then omits the value and the action's
         own default applies, rather than booking the lead as $0. */
      quoted_total:   r.custom ? null : r.season
    };

    sendLead(payload, r);
    /* The name matters: snippets/ss-lead-forms.liquid mirrors Klaviyo events to
       GA4 and Google Ads only when the metric matches /Quote Requested/. Call
       this anything else and the lead is invisible to Ads. */
    ssKlaviyo("Maintenance Quote Requested", payload);
    if (window.dataLayer) window.dataLayer.push({
      event:"maintenance_program_request", value:payload.quoted_season || null,
      reference:ref, property_type:"commercial"
    });

    S.sent = true;
    $("cmdoneName").textContent = "Thanks, " + (payload.first_name || "friend");
    $("cmdoneRef").textContent = "Reference " + ref;
    $("cmsheetBody").style.display = "none";
    $("cmdone").classList.add("show");
    var sheet = $("cmsheet");
    if (sheet) window.scrollTo({ top: sheet.offsetTop - 30, behavior:"smooth" });
  });

  /* ---------------- go ---------------- */
  buildTowns();
  buildCards();
  buildSvcs();
  render();
  loadMaps();
  initMeasure();
})();
